<template>
  <div class="input-item-wrapper">
    <label v-if="labelText" :for="inputId">{{labelText}}</label>
    <number-input v-if="inputType === 'number'"
                  :customError="customError"
                  :isOptOutInput="isOptOutInput"
                  :inputClass="inputClass"
                  :inputId="inputId"
                  :isCurrency="isCurrency"
                  :numberValue="inputValue"
                  :placeholder="placeholder"
                  :step="step"
                  :useCustomValidation="useCustomValidation"
                  :zeroAllowed="zeroAllowed"
                  :min="min"
                  :max="max"
                  @customValidation="customValidation"
                  @saveInput="saveInput"
                  @setErrorText="setErrorText"
                  @setInteractions="setInteractions"></number-input>

    <select-box v-if="inputType === 'select'"
                :options="options"
                :selectClasses="inputClass"
                :selectId="inputId"
                :placeholder="placeholder"
                :selectedOption="inputValue"
                @saveInput="saveInput"
                @setInteractions="setInteractions"></select-box>

    <text-input v-if="inputType === 'text'"
                :inputClass="inputClass"
                :inputId="inputId"
                :placeholder="placeholder"
                :textValue="inputValue"
                :useCustomValidation="useCustomValidation"
                @customValidation="customValidation"
                @saveInput="saveInput"
                @setErrorText="setErrorText"
                @setInteractions="setInteractions"></text-input>

    <small v-if="errorText" class="error-label">{{errorText}}</small>
  </div>
</template>


<script>
  import NumberInput from './NumberInput'
  import SelectBox from './SelectBox'
  import TextInput from './TextInput'

  export default {
    props: {
      customError: String,
      isOptOutInput: Boolean,
      inputClass: String,
      inputId: [Number, String],
      inputType: String,
      inputValue: [Number, String],
      isCurrency: Boolean,
      labelText: String,
      options: Array,
      placeholder: String,
      // tell input if user will have some sort of interaction on blur event
      shouldSetInteractions: Boolean,
      showErrors: Boolean,
      step: [Number, String],
      useCustomValidation: Boolean,
      zeroAllowed: Boolean,
      min: Number,
      max: Number
    },

    name: 'InputItem',

    components: {
      NumberInput,
      SelectBox,
      TextInput,
    },

    data() {
      return {
        errorMessage: null,
      }
    },

    methods: {
      customValidation($target) {
        this.$emit('customValidation', $target, this.inputId)
      },

      saveInput(inputValue) {
        this.$emit('saveInputValue', { [this.inputId]: inputValue })
      },

      setErrorText(errorMessage) {
        this.errorMessage = errorMessage
        this.$emit('setErrors', this.inputId, errorMessage)
      },

      setInteractions() {
        if (this.shouldSetInteractions) { this.$emit('setInteractions', this.inputId) }
      },
    },

    computed: {
      errorText: function() {
        if (this.showErrors) {
          if (this.customError) { return this.customError }
          else if (this.errorMessage) { return this.errorMessage }
        }
      },
    },
  }
</script>
